import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "continue_button_wrapper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ui_continue_button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked'))),
      disabled: _ctx.disabled
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("Button.Continue")), 1),
      _hoisted_3
    ], 8, _hoisted_2)
  ]))
}